import { api } from './client';

export type ShopStatus = {
  shop_open: boolean;
  closure_message: string;
  estimated_ship_date: string;
  paczkomat_cost_a_grosze: number;
  paczkomat_cost_b_grosze: number;
  paczkomat_cost_c_grosze: number;
  kurier_cost_a_grosze: number;
  kurier_cost_b_grosze: number;
  kurier_cost_c_grosze: number;
  booth_address?: string;
  concert_date?: string;
};

export const getShopStatus = () => api.get<ShopStatus>('/shop-status');
